if (!customElements.get('bundle-add-to-cart-button')) {
  customElements.define(
    'bundle-add-to-cart-button',
    class BundleAddToCartButton extends HTMLElement {
      constructor() {
        super();
        this.button = null;
        this.bundleVariants = [];
        this.isProcessing = false;
        this.boundHandleClick = this.handleClick.bind(this);
        this.fallbackTimeout = null;
      }

      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        const variantId = this.dataset.variantId;
        const bundleDataScript = document.querySelector(`script[data-bundle-variants="${variantId}"]`);

        if (bundleDataScript) {
          try {
            this.bundleVariants = JSON.parse(bundleDataScript.textContent.trim());
          } catch (error) {
            console.error('Error parsing bundle variants:', error);
            return;
          }
        }
        this.button.addEventListener('click', this.boundHandleClick);
      }

      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this.boundHandleClick);
        }
        clearTimeout(this.fallbackTimeout);
      }

      waitForLiquidAjaxCartInit(timeout = 5000) {
        if (window.liquidAjaxCart?.init === true) return Promise.resolve(true);

        return new Promise((resolve) => {
          const onInit = () => {
            cleanup();
            resolve(true);
          };
          const timer = setTimeout(() => {
            cleanup();
            resolve(false);
          }, timeout);
          const cleanup = () => {
            clearTimeout(timer);
            document.removeEventListener('liquid-ajax-cart:init', onInit);
          };

          document.addEventListener('liquid-ajax-cart:init', onInit);
        });
      }

      async handleClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isProcessing || !this.button || this.button.disabled) return;

        const sellingPlanId = this.dataset.sellingPlanId || '';
        const isOneTimePurchase = !sellingPlanId;

        // One-time purchase → add all variants
        // Subscription → add only variants that belong to this selling plan
        const matchingVariants = isOneTimePurchase ? this.bundleVariants : this.bundleVariants.filter((variant) =>variant.selling_plan_ids?.includes(sellingPlanId));

        if (!matchingVariants.length) {
          console.error('No bundle variants found with matching selling plan');
          return;
        }

        const itemsForCart = matchingVariants.map((variant) => {
          const item = {
            id: variant.id,
            quantity: Number(variant.quantity) || 1,
            properties: {
              _is_it_bundle: 'true',
            },
          };

          if (!isOneTimePurchase) {
            item.selling_plan = sellingPlanId;
          }

          return item;
        });

        this.setProcessing(true);

        const ready = await this.waitForLiquidAjaxCartInit();

        if (ready && typeof window.liquidAjaxCart?.add === 'function') {
          window.liquidAjaxCart.add({ items: itemsForCart });

          const handleRequestEnd = (event) => {
            const { requestState } = event.detail;
            if (requestState.requestType === 'add') {
              clearTimeout(this.fallbackTimeout);
              this.setProcessing(false);
              document.removeEventListener('liquid-ajax-cart:request-end', handleRequestEnd);
            }
          };

          document.addEventListener('liquid-ajax-cart:request-end', handleRequestEnd);

          this.fallbackTimeout = setTimeout(() => {
            document.removeEventListener('liquid-ajax-cart:request-end', handleRequestEnd);
            this.setProcessing(false);
          }, 3000);
        } else {
          console.error('Liquid Ajax Cart add API not available');
          this.setProcessing(false);
        }
      }

      setProcessing(isProcessing) {
        this.isProcessing = isProcessing;
        if (!this.button) return;
        const text = this.button.querySelector('span');

        if (isProcessing) {
          this.button.disabled = true;
          if (text) text.style.opacity = '0.5';
        } else {
          this.button.disabled = false;
          if (text) text.style.opacity = '1';
        }
      }
    }
  );
}